import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Leaf, LogOut, Menu, User, MapPin } from "lucide-react";
import { useState } from "react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const linkCls = ({ isActive }) =>
    `text-sm font-semibold transition-colors ${
      isActive ? "text-[#4A6B53]" : "text-[#58625B] hover:text-[#2C312E]"
    }`;

  return (
    <header className="sticky top-0 z-40 bg-[#FBF9F6]/85 backdrop-blur-xl border-b border-[#E5DCD0]">
      <div className="mx-auto max-w-7xl px-6 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="navbar-logo">
          <img
            src="/logo-agrigiochiamo.gif"
            alt="Agrigiochiamo Network"
            className="h-12 w-auto rounded-xl group-hover:scale-105 transition-transform"
          />
          <span className="hidden sm:inline font-display font-black text-lg tracking-tight text-[#2C312E]">
            Agri<span className="text-[#C8795A]">Giochi</span><span className="text-[#4A6B53]">Amo</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <NavLink to="/" end className={linkCls} data-testid="nav-home">Home</NavLink>
          <NavLink to="/fattorie" className={linkCls} data-testid="nav-fattorie">Fattorie</NavLink>
          <NavLink to="/chi-siamo" className={linkCls} data-testid="nav-about">Il Network</NavLink>
          <NavLink to="/progetti" className={linkCls} data-testid="nav-projects">Progetti</NavLink>
          <NavLink to="/adesione" className={linkCls} data-testid="nav-join">Unisciti</NavLink>
          <NavLink to="/segnala" className={linkCls} data-testid="nav-suggest">Segnala</NavLink>
          {user?.role === "admin" && (
            <NavLink to="/admin" className={linkCls} data-testid="nav-admin">Admin</NavLink>
          )}
          {user && user.role !== "admin" && (
            <NavLink to="/dashboard" className={linkCls} data-testid="nav-dashboard">Area Personale</NavLink>
          )}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {!user ? (
            <>
              <Link to="/login" className="text-sm font-semibold text-[#58625B] hover:text-[#2C312E]" data-testid="nav-login">
                Accedi
              </Link>
              <Link
                to="/register"
                className="inline-flex items-center gap-2 rounded-full bg-[#4A6B53] text-white px-5 py-2.5 text-sm font-bold hover:bg-[#3D5844] transition-all hover:-translate-y-0.5 shadow-sm"
                data-testid="nav-register"
              >
                <User size={16} /> Registrati
              </Link>
            </>
          ) : (
            <div className="flex items-center gap-3">
              <span className="text-sm text-[#58625B]">Ciao, <span className="font-bold text-[#2C312E]">{user.name?.split(" ")[0]}</span></span>
              <button
                onClick={async () => { await logout(); navigate("/"); }}
                className="inline-flex items-center gap-2 rounded-full border-2 border-[#E5DCD0] px-4 py-2 text-sm font-semibold hover:border-[#C8795A] hover:text-[#C8795A] transition-all"
                data-testid="nav-logout"
              >
                <LogOut size={16} /> Esci
              </button>
            </div>
          )}
        </div>

        <button
          className="md:hidden p-2 rounded-xl border border-[#E5DCD0]"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
        >
          <Menu size={20} />
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#E5DCD0] bg-[#FBF9F6] px-6 py-4 flex flex-col gap-3">
          <NavLink to="/" end onClick={() => setOpen(false)} className={linkCls}>Home</NavLink>
          <NavLink to="/fattorie" onClick={() => setOpen(false)} className={linkCls}>Fattorie</NavLink>
          <NavLink to="/chi-siamo" onClick={() => setOpen(false)} className={linkCls}>Il Network</NavLink>
          <NavLink to="/progetti" onClick={() => setOpen(false)} className={linkCls}>Progetti</NavLink>
          <NavLink to="/adesione" onClick={() => setOpen(false)} className={linkCls}>Unisciti</NavLink>
          <NavLink to="/segnala" onClick={() => setOpen(false)} className={linkCls}>Segnala</NavLink>
          {user?.role === "admin" && <NavLink to="/admin" onClick={() => setOpen(false)} className={linkCls}>Admin</NavLink>}
          {user && user.role !== "admin" && <NavLink to="/dashboard" onClick={() => setOpen(false)} className={linkCls}>Area Personale</NavLink>}
          {!user ? (
            <>
              <Link to="/login" onClick={() => setOpen(false)} className="text-sm font-semibold">Accedi</Link>
              <Link to="/register" onClick={() => setOpen(false)} className="text-sm font-bold text-[#4A6B53]">Registrati</Link>
            </>
          ) : (
            <button onClick={async () => { await logout(); setOpen(false); navigate("/"); }} className="text-left text-sm font-semibold text-[#C8795A]">Esci</button>
          )}
        </div>
      )}
    </header>
  );
}
